import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleAlbumMetaData: (field: string, value: string | null) => void;
};

export default function UnitsPerSetFormGroup({
  album,
  readonly,
  disabled,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumMetaData,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.unitsPerSet')}
        handleInput={(e) => handleAlbumMetaData('unitsPerSets', e.target.value)}
        id="unitsPerSets"
        type="number"
        value={album.albumMetaData?.unitsPerSets?.toString() ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('UnitsPerSets')}
        errorMessage={findErrorMessage('UnitsPerSets')}
        isRequired={true}
        showValidationErrors={showValidationErrors}
        fieldValidationKey={'productEditMode.UnitsPerSets'}
      />
    </div>
  );
}
